<template>
    <div class="my-table myDocPage">
        <!-- 面包屑组件 -->
        <div class="searchBox flexCenter">
          <div class="fl">
            <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt1')" placement="top-start">
                <div class="btnC addBtn" @click="selectUploadType('file')">
                    <img class="btnIcon" src="@/assets/picture/icon/icon-upload1.png">
                    <input type="file" class="upload-btn" id="fileUpload" ref="fileInput" @change="uploadFile">
                </div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt2')" placement="top-start">
                <div class="btnC addBtn2" @click="selectUploadType('dir')">
                    <img class="btnIcon" src="@/assets/picture/icon/icon-upload2.png">
                    <!-- <span class="btn-txt">文件夹</span> -->
                    <input type="file" class="upload-btn" id="dirUpload" ref="fileInput2" webkitdirectory mozdirectory msdirectory odirectory directory @change="uploadFile">
                </div>
            </el-tooltip>
            <span></span>
            <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt3')" placement="top-start">
                <div class="btnC addBtn" @click="handleAdd">
                 <img class="btnIcon" src="@/assets/picture/icon/icon-newFile.png">
             </div>
         </el-tooltip>
         <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt4')" placement="top-start">
            <div @click="handleDelete" class="btnC addBtn">
                <img class="btnIcon" src="@/assets/picture/icon/icon-delete.png">
            </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt5')" placement="top-start">
            <div @click="handleRename" class="btnC addBtn">
                <img class="btnIcon" src="@/assets/picture/icon/icon-rename.png">
            </div>
        </el-tooltip>
        <span :style="{display:(enableDowloadUserData=='true'?'inline-block':'none')}">
            <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt6')" placement="top-start">
                <div class="btnC addBtn" @click="handleDownload">
                 <img class="btnIcon" src="@/assets/picture/icon/icon-download.png">
             </div>
         </el-tooltip>
     </span>
     <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt7')" placement="top-start">
        <div @click="handleShare" class="btnC addBtn">
            <img class="btnIcon" src="@/assets/picture/icon/icon-share.png">
        </div>
    </el-tooltip>
         <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt39')" placement="top-start">
        <div @click="handleDownloadClient" class="btnC addBtn">
            <img class="btnIcon" src="@/assets/picture/icon/win.png">
        </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" :content="$t('myDoc.txt42')" placement="top-start">
        <div @click="startClient" class="btnC addBtn">
            <img class="btnIcon" src="@/assets/picture/icon/open.png">
        </div>
    </el-tooltip>
               <!--  <el-tooltip class="item" effect="dark" content="添加到项目" placement="top-start">
                    <div @click="handleSaveToProject" class="btnC addBtn">
                        <img class="btnIcon" src="@/assets/picture/icon/icon_addProject.png">
                    </div>
                </el-tooltip> -->
            </div>
            <div class="flexEnd">
                <div class="handleBoxSelect">
                  <el-select v-model="isList" :placeholder="$t('myDoc.txt8')">
                    <el-option
                    v-for="(item,index) in showList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="handleBoxSeach flexCenter">
          <el-input
          :placeholder="$t('myDoc.txt9')"
          v-model="searchPath" @keypress.native.enter="handleFind">
          <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
      </el-input>
      <div class="searchBtn" @click="handleFind">{{$t('myDoc.txt10')}}</div>
  </div>
</div>
</div>
<!-- 面包屑 -->
<div class="searchBox flexCenter searchBoxBreak">
  <div class="current-location">
    <img class="location" src="@/assets/picture/icon/location.png">
    <span>{{$t('myDoc.txt11')}}</span>
    <span class="pathC" @click="toRootPath">{{$t('myDoc.txt12')}} / {{$t('myDoc.txt13')}}</span>
    <span v-for="(item, index) in paths" :key="item.path" @click="handleFlooder(index)"> / <span class="link" > {{item.localPath}}</span></span>
</div>
</div>
    <disk-main
   ref="diskMain"
   :dataList="dataList"
   :paths="paths"
   :isList="isList"
   @openFloder="openFloder"
   v-loading="loading"
   :multipleSelection.sync="multipleSelection"></disk-main>
   <!-- <Share :visible.sync="dialogFormVisible" :patahs="multipleSelection"></Share> -->
   <Project :visible.sync="visibleSelectProject" @success="confirmSelectProject"></Project>
   <!-- 文件上传重名 -->
  <el-dialog
  :title="$t('myDoc.txt34')"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <span>{{$t('myDoc.txt35')}}</span>
  <span slot="footer" class="el-message-box__btns">
    <el-button @click="dialogVisible = false">{{$t('myDoc.txt36')}}</el-button>
    <el-button @click="onRepeatUpload(1)">{{$t('myDoc.txt37')}}</el-button>
    <el-button type="primary" @click="onRepeatUpload(2)">{{$t('myDoc.txt38')}}</el-button>
  </span>
</el-dialog>
<!-- 下载客户端 -->
  <el-dialog
 class="downloadClientDialog"
 show-close
  title=""
  :close-on-click-modal="true"
  @close="downloadClientDialog=false"
  :visible.sync="downloadClientDialog"
  :before-close="handleCloseDownloadClient">
  <p class="title">{{$t('myDoc.txt39')}}</p>
  <span class="tips">{{$t('myDoc.txt40')}}</span>
     <div class="downTypeBox">
        <div class="item" @click="openClient(item)" v-for="(item,index) in clients" :key="index">
          <div class="imgBox">
              <img class="img" :src="apiUrl + '/'+ item.icon"> 
          </div>
            <span class="txt">{{item.name}}</span>
        </div>
  </div>
 
</el-dialog>

        </div>
    </template>
    <script>
        import {apiUrl,serverUrl} from '@/utils/request';
        import { formatDate } from "@/plugins/date.js";
        import qs from 'qs';
        const cityOptions = [];
        import diskMain from './components/DiskMain';
        //import { uploadFile, downloadFile } from '@/utils/fileRequest';
        import Project from './components/Project'
        export default {
            components: {
                diskMain,
                Project
            },
            data() {
                let userInfo = JSON.parse(localStorage.userInfo)
                const generateData = _ => {
                    const data = [];
                    for (let i = 1; i <= 15; i++) {
                        data.push({
                            key: i,
                            label: `this.$t("myDoc.txt10") ${ i }`,
                            disabled: i % 4 === 0
                        });
                    }
                    return data;
                };
                return {
                    apiUrl,
                    userInfo,
                    data: generateData(),
                    value: [1, 4],
                    isList:false,
                    activeName:'first',//tab切换
                    multipleSelection: [],
                    checkAll: false,
                    checkedCities: [],
                    cities: cityOptions,
                    isIndeterminate: true,
                    time:'',
                    fromData:{},//分享参数
                    options:[],//有效期
                    shareList:[],
                    //用于获取数据列表
                    queryInfo: {
                        mobile: '',
                        page: 0,
                        realName: '',
                        size: 10,
                        userName: '',
                    },
                    showList:[
                    {
                        label:this.$t("myDoc.txt15"),
                        value:true
                    },
                    {
                        label:this.$t("myDoc.txt16"),
                        value:false
                    }
                    ],
                    dataList: [],
                    total: 0,
                    paths: [],
                    searchPath: '',
                    isSearch: false,
                    visibleSelectProject: false,
                    enableDowloadUserData:true,
                    downloadLoading: false,
                    uploadType:'file',//上传类型，file为文件，dir为文件夹
                    dialogVisible:false,//文件上传检测重名
                    event:null,//上传事件
                    downloadClientDialog:false,//下载客户端对话框
                    clients:[],//客户端数组
                    fileName:'',//上传文件夹/文件名称
                    newName:'',//检查是否重名，直接用返回的newName
                    uploading: false, //正在上传
                    progress: 0, //上传进度条
            };
        },
        created() {
            // this.getOSnow();
            this.loadData();
            this.enableDowloadUserData = window.sessionStorage.getItem("enableDowloadUserData");
            console.log(this.enableDowloadUserData,'this.enableDowloadUserData');
        },
        computed: {
            currentPath() {
                let { paths } = this;
                if(!paths.length) return '';
                return paths[paths.length - 1].path
            }
        },
        filters: {
            formatDate(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            },
        },
        methods: {
            // 获取当前操作系统
            getOSnow(){
              var agent = navigator.userAgent.toLowerCase();
              var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
              if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
                console.log("这是windows32位系统");
                }
              if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
                console.log("这是windows64位系统");
              }
              if(isMac){
                console.log("这是mac系统");
              }
            },
            toRootPath() {
                this.paths = []
                this.loadData()
            },
            handlePrevDir() {
                this.handleFlooder(this.paths.length - 1)
            },
            handleFlooder(index) {
              this.paths = this.paths.slice(0, index + 1)
              this.loadData()
          },
            // 进入文件夹
            openFloder(item) {
                this.paths.push(item)
                this.loadData();
            },
            async uploadFile(e) {               
                
                // if(this.uploadType == 'file'){
                //    var upload = document.getElementById('fileUpload');
                //    // 获取文件名
                //    this.fileName = upload.files[0].name;
                // }else{
                //    var theFiles = e.target.files;
                //    var relativePath = theFiles[0].webkitRelativePath;
                //    var folder = relativePath.split("/");
                //    // 获取文件名
                //    this.fileName = folder[0];
                // }
                // this.event = e;
                // // 获取上传文件大小
                // let totalSize = 0;
                // let files =  e.target.files;
                // for (let i = 0; i < files.length; i++) {
                //     totalSize += files[i].size;
                // }   
                // // 字节转换成MB
                //  let byte = (totalSize / (1024 * 1024)).toFixed(2);
                //  console.log(byte,'byte')
                //  sessionStorage.removeItem('projectId');//清除项目文件上传时的项目id
                // // 统计文件总大小是否大于500M
                // if(byte>500){
                //     // 启动客户端
                //     this.startClient();
                // }else{
                //     // 调用接口检查是否有同名文件
                //     this.checkFileSameName(e);
                // }

                if(this.uploading){
                    this.$message({
                        message: '当前任务正在进行中,任务完成后再上传!',
                        type: 'warning'
                    });
                    return;
                }

                //新的上传方式
                const notification = this.$notify({
                    //title: '上传进度',
                    message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
                    position: 'bottom-right',
                    offset: 100,
                    showClose: false, //不显示关闭按钮
                    dangerouslyUseHTMLString: true, // 关键：允许解析HTML
                    duration: 0, // 关键：设置为0表示不自动关闭
                    customClass: 'custom-upload-notify' // 添加自定义类名
                });

                if(this.uploadType == 'file'){
                    var upload = document.getElementById('fileUpload');
                    // 获取文件名
                    this.fileName = upload.files[0].name;

                    const files = e.target.files;
                    if (files.length === 0) return;

                    this.uploading = true;
                    this.progress = 0;

                    const formData = new FormData();                    
                    //上传到的目录
                    formData.append('dir', this.currentPath);
                    // 添加所有文件到FormData（保留目录结构）
                    Array.from(files).forEach(file => {
                        formData.append('files', file);
                    });
                    try {
                        const response = await this.$http.post(
                        '/user/info/uploadFile',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: (progressEvent) => {
                                if (progressEvent.total) {
                                    this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    console.log(this.progress)                                    
                                    var uploadProgress = document.getElementById('uploadProgress');
                                    uploadProgress.value = this.progress;

                                    var uploadProgressText = document.getElementById('uploadProgressText');
                                    uploadProgressText.innerHTML = this.progress+"%";
                                }
                            }
                        }
                        );
                        console.log('上传成功:', response.data);
                        //alert('文件上传成功！');
                        this.loadData(); //加载文件列表
                    } catch (error) {
                        console.error('上传失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        notification.close() //关闭进度条
                    }

                }else{ //文件夹

                    //    var theFiles = e.target.files;
                    //    var relativePath = theFiles[0].webkitRelativePath;
                    //    var folder = relativePath.split("/");
                    //    // 获取文件名
                    //    this.fileName = folder[0];
                    const files = e.target.files;
                    if (files.length === 0) return;
                
                    this.uploading = true;
                    this.progress = 0;
                
                    const formData = new FormData();                
                    //上传到的目录
                    formData.append('dir', this.currentPath);
                
                    // 添加所有文件到FormData（保留目录结构）
                    Array.from(files).forEach(file => {
                        formData.append('files', file, file.webkitRelativePath);
                    });
                
                    try {
                        const response = await this.$http.post(
                            '/user/info/uploadFolder',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                onUploadProgress: (progressEvent) => {
                                    if (progressEvent.total) {
                                        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                            console.log(this.progress)                                 
                                            var uploadProgress = document.getElementById('uploadProgress');
                                            uploadProgress.value = this.progress;

                                            var uploadProgressText = document.getElementById('uploadProgressText');
                                            uploadProgressText.innerHTML = this.progress+"%";
                                    }
                                }
                            }
                        );
                
                        console.log('上传成功:', response.data);
                        //alert('文件夹上传成功！');
                        this.loadData(); //加载文件列表
                    } catch (error) {
                        console.error('上传失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        notification.close() //关闭进度条
                    }
                }
          },
          // 启动客户端
          startClient(path){
            let downloadFilePath = path?path:'';
            let loginName = window.sessionStorage.getItem("loginName");
             var info = JSON.stringify({
              username: loginName, // 用户名，当前登录的账号名
              server: "http://"+window.location.hostname+":36003", //服务端地址，开发时获取浏览器的ip用拼接: "http://"+window.location.hostname+":36003"
              // downloadFilePath: '/home/sysmanager/file1', //自动下载的文件路径,file1是文件路径绝对路径，如果单纯的打开客户端，这里留空即"",即可
              downloadFilePath: downloadFilePath, //
              downloadIsDir: path?true:false//自动下载的是不是文件夹，文件夹: true, 文件: false
            })
            // 生成拉起App的地址
            var url = window.StartAppUrl(info);
            window.location.href = url;
            this.$refs.fileInput.value = '';
            this.$refs.fileInput2.value = '';
          },
         // 检查上传文件是否同名
        async checkFileSameName(e){
            let { currentPath } = this;
            let isUploadFolder = this.uploadType == 'file'?false:true;//
            // // let fileName = this.$store.state.fileName;
            // let fileName =window.sessionStorage.getItem("fileName");
            const { data: res } = await this.$http.get("/user/info/checkFileSameName?path=" + currentPath+'&fileName='+this.fileName+'&isUploadFolder='+isUploadFolder);
            if(!res.success){
                return this.$message.error(res.message);
            }
            this.newName = res.result.newName;
            // 若tag为1,则说明该文件重名
           if(res.tag== 1){
            this.dialogVisible = true;
           }else{
            this.onRepeatUpload(1);
                // let url = this.uploadType == 'file'?'/user/info/upload':'/user/info/upload/folder/file';
                // this.$store.dispatch('UPLOAD', {
                //   url: url,
                //   event: e,
                //   path: this.currentPath,
                //   operation:1,
                //   uploadNewFileName:this.fileName,
                //   cb: () => {
                //     e.target.value = null;
                //     this.loadData();
                // }
            // })
           }
        },
        // 文件重命名上传
        onRepeatUpload(type){
            let operation = type;   //重名时用到,上传操作,0:忽略,1:覆盖,2:保存两者,3:继续上传
            this.dialogVisible = false;
            let fileName =window.sessionStorage.getItem("fileName");
             let url = this.uploadType == 'file'?'/user/info/upload':'/user/info/upload/folder/file';
                this.$store.dispatch('UPLOAD', {
                  url: url,
                  event: this.event,
                  path: this.currentPath,
                  operation:operation,
                  uploadNewFileName:this.newName,
                  // uploadNewFileName:this.fileName,
                  cb: () => {
                    this.event.target.value = null;
                    this.loadData();
                }
            })
            this.$refs.fileInput.value = '';
            this.$refs.fileInput2.value = '';
        },
          handleClose() {
            this.searchPath = '';
            this.handleFind()
        },
        handleCloseDownloadClient(){
            this.downloadClientDialog=false;
        },
        // 获取数据同步客户端列表
        async getClientToolsList(){
            const { data: res } = await this.$http.get("/user/info/getClientToolsList");
            if(!res.success){
                return this.$message.error(res.message);
            }
            this.clients = res.result || [];
        },
        // 获取数据同步客户端列表
        async openClient(item){
            window.location.href = apiUrl+"/user/info/downloadClientTools?id="+item.id;
        },
        async handleFind() {
            if(this.searchPath === ''){
                this.isSearch = false;
                this.paths = [];
                this.loadData()
                return 
            }
            this.isSearch = true;
            this.paths = [];
            this.loading = true;
            let { currentPath } = this;
            const { data: res } = await this.$http.post("/user/info/disk/find?key="+this.searchPath);
            this.loading = false;
            if(!res.success){
                return this.$message.error(res.message);
            }
            res.result && res.result.forEach(item => {
                item.localPath = item.path.replace(new RegExp('^' + currentPath + '/'), '')
                if(item.directory) {
                    item.changeName = false;
                }
                else {
                    item.fileType = this.getFileType(item.path)
                }
            })
            this.dataList = res.result || [];
        },
            // 数据加载
            async loadData(){
                this.loading = true;
                let { currentPath } = this;
                const { data: res } = await this.$http.post("/user/info/disk?path=" + currentPath);
                this.loading = false;
                if(!res.success){
                    return this.$message.error(res.message);
                }
                res.result && res.result.forEach(item => {
                    item.localPath = item.path.replace(new RegExp('^' + currentPath + '/'), '')
                    if(item.directory) {
                        item.changeName = false;
                    }
                    else {
                        item.fileType = this.getFileType(item.path)
                    }
                })
                this.dataList = res.result || [];
            },
            getFileType(name) {
                let arr = name.split('.')
                return arr[arr.length - 1];
            },
            getSelection() {
                return new Promise((resolve) => {
                    if(this.isList) {
                        if(this.multipleSelection.length) {
                            resolve(this.multipleSelection.map(item =>item.path))
                        }
                        else {
                            this.$message.warning(this.$t("myDoc.txt17"))
                        }
                    }
                    else {
                        const list = this.$refs.diskMain.checkedList;
                        if(list.length) {
                            resolve(list)
                        } 
                        else {
                            this.$message.warning(this.$t("myDoc.txt17"))
                        }
                    }
                })
            },
            getSizeSelection() {
                return new Promise((resolve) => {
                    if(this.isList) {
                        if(this.multipleSelection.length) {
                            resolve(this.multipleSelection.map(item =>item.size))
                        }
                        else {
                            this.$message.warning(this.$t("myDoc.txt17"))
                        }
                    }
                    else {
                        const list = this.$refs.diskMain.checkedList;
                        if(list.length) {
                            resolve(list)
                        } 
                        else {
                            this.$message.warning(this.$t("myDoc.txt17"))
                        }
                    }
                })
            },
            // 删除
            async handleDelete(){
                let list = await this.getSelection()
                this.$confirm('<p class="color666 fz14">'+this.$t("myDoc.txt18")+'</p><p class="color999 fz14">'+this.$t("myDoc.txt19")+'</p>', this.$t("myDoc.txt4"), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t("myDoc.txt20"),
                    cancelButtonText: this.$t("myDoc.txt21"),
                    type: 'warning',
                    center: true,
                }).then(e => {
                    this.confirmDeleteDir(list)
                })
            },
            async handleRename() {
                let lists = await this.getSelection()
                let list = [];
                list.push(lists[lists.length - 1])
                console.log(lists,'lists')
                if(lists.length > 1) {
                    this.$message.warning(this.$t("myDoc.txt22"))
                    return
                }
                let path = list[0].replace(this.currentPath + '/', '');

                this.$prompt('', this.$t("myDoc.txt23"), {
                    confirmButtonText: this.$t("myDoc.txt20"),
                    cancelButtonText: this.$t("myDoc.txt21"),
                    inputValue: path,
                }).then(async ({value}) => {
                    const { data: res } = await this.$http.post(`/user/info/rename?path=${list[0]}&newPath=${this.currentPath + '/' + value}`);
                    if(!res.success){
                        return this.$message.error(res.message);
                    }
                    this.$message({
                        type: 'success',
                        message: this.$t("myDoc.txt24")
                    });
                    this.loadData();
                })
            },
            async confirmDeleteDir(list) {
                const { data: res } = await this.$http.post("/user/info/dir/delete", JSON.stringify(list));
                if(!res.success){
                    return this.$message.error(res.message);
                }
                this.$message({
                    type: 'success',
                    message: this.$t("myDoc.txt25")
                });
                this.loadData();
            },
            async handleShare() {
                let list = await this.getSelection()
                this.shareList = list;
                this.$router.push({path: '/patfromShare', query: {row: JSON.stringify(list)}});
            },
            // 下载客户端
            handleDownloadClient(){
                this.downloadClientDialog = true;
                this.getClientToolsList();
            },
            async handleSaveToProject() {
                await this.getSelection()
                this.visibleSelectProject = true;
            },
            async confirmSelectProject(row) {
                // 保存至项目
                const list = await this.getSelection()
                const { data: res } = await this.$http.post("/user/info/save/to/project?projectId=" + row.id, list);
                if(!res.success){
                    return this.$message.error(res.message);
                }
                this.$message({
                    type: 'success',
                    message: this.$t("myDoc.txt26")
                });
                this.visibleSelectProject = false;
            },
            getDirkName() {
                let i = 1;
                let { dataList } = this;
                return getName();
                function getName() {
                    let one = dataList.find(item => item.directory && item.localPath === '文件夹' + i)
                    if(one) {
                        i++
                        return getName()
                    }
                    else {
                        return '文件夹' + i
                    }
                }
            },
            selectUploadType(type) {
                switch(type) {
                    case 'file':
                        this.uploadType = 'file';
                        window.sessionStorage.setItem("uploadType",this.uploadType);
                        this.$refs.fileInput.click()
                        break;
                    case 'dir':
                        this.uploadType = 'dir';
                        window.sessionStorage.setItem("uploadType",this.uploadType);
                        this.$refs.fileInput2.click()
                        break;
                    default:
                        return
                }
            },
            // 新增文件
            handleAdd(){
                let name = this.getDirkName()
                const { currentPath } = this;
                this.$prompt(this.$t("myDoc.txt28"), this.$t("myDoc.txt29"), {
                    confirmButtonText: this.$t("myDoc.txt20"),
                    cancelButtonText: this.$t("myDoc.txt21"),
                    inputValue: name,
                }).then(({ value }) => {
                    this.mkdir(currentPath == '' ? (currentPath + value) : (currentPath + '/' + value))
                })
            },
            validateJyh(glhm){//校验关联用户名
                var reg = new RegExp(/^[a-zA-Z]{1}\w*$/);
                if(!reg.test(glhm)){
                    this.$message.error(this.$t("myDoc.txt30"));
                }
                this.mkdir(glhm);
            },
            // 新建文件夹
            async mkdir(path){
                const { data: res } = await this.$http.post("/user/info/mkdir?path="+path);
                if(!res.success){
                    return this.$message.error(res.message);
                }
                else{
                    this.$message({
                        type: 'success',
                        message: this.$t("myDoc.txt31")
                    });
                    this.loadData();
                }
            },
            // 编辑
            handleEdit(row){
                this.$router.push({path: "/sceneRecordEdit",query: {id: row.id}});
            },
            // 搜索
            handleSearch(){
                this.queryInfo.pageNum = 1;
                this.queryInfo.pageSize = 10;
                this.loadData();
            },
            // 重置
            handleReset(){
                this.queryInfo = {
                    keyword:'',
                    manufacturerName:'',
                    mobile:'',
                    pageIndex: 1,
                    pageSize: 10,
                    pageSorts: [
                    {
                        asc: true,
                        column: ''
                    }
                    ],
                    projectName: ''
                };
                this.loadData();
            },
            // 编辑/详情
            handleDetail(row,type){
                this.$router.push({path: "/sceneRecordDetail",query: {type: type,id: row.id}});
            },
            // 页面切换
            handleCurrentChange(pageNum) {
                this.queryInfo.pageNum = pageNum;
                this.loadData();
            },
            handleSizeChange(pageSize){
                this.queryInfo.pageSize = pageSize;
                this.loadData();
            },
            async delete(row){
                const { data: res } = await this.$http.delete("/dmp-es-admin/sms/smsWitnRec/deleteBatch?ids="+row.id);
                if(res.code !== 200){
                    return this.$message.error(res.message);
                }
                this.$message({
                    type: 'success',
                    message: this.$t("myDoc.txt25")
                });
                this.loadData();
            },
            // async handleDownload() {
            //     this.getSelection().then(async list => {
            //         await downloadFile('post', '/user/info/download', list)
            //     })
            //     // this.getSelection().then(async list => {
            //     //     const data = list.map(item => item.path)
            //     //     // const res = await downloadFile('get', '/user/info/template/download')
            //     //     const res = await downloadFile('post', '/user/info/download', data)
            //     // })
            // },
            // 下载
            async handleDownload() {

                this.getSelection().then(async list => {
                    if(this.uploading){
                        console.log("任务进行中,请稍后!")
                        this.$message({
                            message: '任务进行中,请稍后!',
                            type: 'warning'
                        });
                        return;
                    }
                    const notification = this.$notify({
                        //title: '上传进度',
                        message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
                        position: 'bottom-right',
                        offset: 100,
                        showClose: false, //不显示关闭按钮
                        dangerouslyUseHTMLString: true, // 关键：允许解析HTML
                        duration: 0, // 关键：设置为0表示不自动关闭
                        customClass: 'custom-upload-notify' // 添加自定义类名
                    });                          
                
                    //隐藏进度条，只显示中文即可
                    var uploadProgress = document.getElementById('uploadProgress');
                    uploadProgress.style.display = 'none';

                    var uploadProgressText = document.getElementById('uploadProgressText');
                    uploadProgressText.innerHTML = "正在打包中,请稍等";
                                    
                    let lists = list.map(item => item)
                    if(lists.length>1){
                        this.$message.warning(this.$t("myDoc.txt41"))
                        return
                    }
                    console.log(lists,'lists')
                    console.log( this.dataList,'this.dataList')    

                    this.uploading = true;
                    this.progress = 0;
                    try {
                        const response = await this.$http.post('/user/info/getDownloadFilePath',JSON.stringify(lists));
                        console.log('获取url', response.data);

                        const zip = response.data.result;
                        console.log(zip)
                        var url = this.$http.defaults.baseURL + "/user/info/download?path=" + zip;
                        console.log(url)
                        

                        //创建隐藏的<a>标签
                        const link = document.createElement("a");
                        link.href = url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                    } catch (error) {
                        console.error('获取url失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        // e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        //稍后关闭进度条
                        setTimeout(() => {
                            notification.close() //关闭进度条
                        }, 800);                            
                    }                    
                })

            },
            confirmProjName() {

            },
        },
    };
</script>

<style lang="less" scoped>
    .addBtn {
        background: transparent !improtant;
        border: none;
    }
    .theme_black{
        .addBtn {
            border: 1px solid #fff;
            color: #fff;
        }
    }
    .myDocPage{
        .btnIcon{
            background-color: transparent;
            width: 22px;
            height: 22px;
            margin-right: 28px;
        }
        .inputProjectName{
          margin-left: 20px;
          /deep/ .el-input__inner{
            height: 30px;
            line-height: 30px;
        }
    }
    .searchBoxBreak{
        padding: 30px 0;
    }
    .showType{
      font-size: 1.4rem;
      font-weight: 400;
      color: #1B3B7C;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
  }
  .searchBox{
      .flex{
        position: absolute;
        right: 0;
    }
}
/deep/ .el-dialog{
      /*/deep/ .el-form-item:first-of-type,/deep/ .el-form-item:last-of-type{*/
     /*margin-bottom: 0;*/
   /*}*/
        /deep/ .el-dialog__body{
            padding: 0 3.6rem !important;
        }
        /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
            border-radius: 8px;
        }
        .el-message-box__btns{
            width: 100% !important;
            display: flex;
            .el-button--primary{
                border-radius: 50px;
            }

        }
    }

}
/deep/ .downloadClientDialog{
  .el-dialog__body{
      position: relative;
      height: 50vh;
  }
    .el-dialog__header{
        border:none;
        height:50px;
    }
    .el-dialog__headerbtn{
        display: block !important;
    }
    .title{
        font-size: 30px;
        color: #333;
        text-align: center;
    }
    .tips{
        color: #BEBEBE;
        display: block;
        font-size: 14px;
        text-align: center;
        margin-bottom: 76px;
    }
    .downTypeBox{
        overflow: hidden;
        clear: both;
        display: flex;
        padding:0 60px;
        position: absolute;
        left:50%;
        transform: translate(-50%,0); 
        .item{
            margin-right: 43px;
            margin-bottom: 100px;
            cursor: pointer;
        }
        .item:last-of-type{
          margin-right: 0;
        }
        item:last-of-type{
            margin-right: 0;
        }
        .imgBox{
             width: 167px;
            height: 104px;
            position: relative;
            display: block;
            line-height: 104px;
            background-color: rgba(249, 249, 249, 1);
            text-align: center;
            border: 1px solid rgba(54, 88, 157, 1);
            margin-bottom: 11px;
        }
        .imgBox:hover{
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
        }
        .img{
            width: 60px;
            position: absolute;
            left: 50%;top: 50%;transform: translate(-50%, -50%);
        }
        .txt{
            color: #BEBEBE;
            font-size: 14px;
            text-align: center;
            display: block;
        }
    }
}
.btnC{
  position: relative;
}
.mr2{
    margin-right: 1rem !important;
}
.upload-btn{
  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
  opacity: 0;
  top: 0;
  left: 0;
  cursor: pointer;
}
.pathC{
    cursor: pointer;
}

//上传进度
/* 深度选择器覆盖 */
.custom-upload-notify{
  width: 240px !important;
  padding: 0px !important;
}
/* Vue 2 深度选择器 */
.theme_white /deep/ .el-notification.right {
  width: 250px;
}
</style>
